import ConfirmInviteForm from '@/components/auth/ConfirmInviteForm';
import { useAuthProvider } from '@/hooks/auth/useAuthProvider';

export default function ConfirmInvite() {
	const { handleConfirmInvite, loadingState } = useAuthProvider();
	return (
		<div className="flex-1">
			<ConfirmInviteForm
				handleSubmit={handleConfirmInvite}
				loading={loadingState.confirmUser}
			/>
		</div>
	);
}
